import * as core from '../../../../../core'

export const RESOURCE = {
  payload: {
    agentId: core.agent.Agent.Id.PrincetonAscendArchitect,
  },
  type: core.quiver.Resource.Type.Agent,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.Agent>
